export default "__VITE_ASSET__36b48aa8__$_?component__"